import { point } from "@turf/turf";
import { useMapLibre } from "@/hooks/use-maplibre";
import { Site, ThemeTypeEnum } from "@/types";
import { getThemeColor } from "@/utils";

function useSite(site?: Site) {
  const _site = site;

  const { flyTo } = useMapLibre();

  const getShape = (site?: Site) => {
    const data = site || _site;

    if (data) {
      switch (data.type) {
        case "zone":
          return "hexagon";
        case "station":
          return "triangle";
        case "point":
        default:
          return "circle";
      }
    }

    return undefined;
  };

  const getPoint = (site?: Site) => {
    const data = site || _site;

    if (data?.longitude && data.latitude) {
      return point([data.longitude, data.latitude], { ...site });
    }
    return undefined;
  };

  const getColor = (site?: Site) => {
    const data = site || _site;
    if (data) {
      return getThemeColor(data.theme as ThemeTypeEnum);
    }
    return undefined;
  };

  const getSprite = (site?: Site) => {
    const data = site || _site;
    const shape = getShape(data);
    const color = getColor(data);

    if (shape && color) {
      return `${shape}-${color}`;
    }
    return undefined;
  };

  const getPosition = (site?: Site) => {
    const data = site || _site;
    if (data) {
      return { lng: data.longitude, lat: data.latitude };
    }
  };

  const locate = (site?: Site, zoom?: number) => {
    const data = site || _site;
    const position = getPosition(data);

    if (position) {
      flyTo(position, zoom);
      return true;
    }
    return false;
  };

  return {
    getShape,
    getPoint,
    getColor,
    getSprite,
    getPosition,
    locate,
  };
}

export { useSite };
